import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import _ from "lodash";
import moment from "moment";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: true,
    isSidebarOpen: false,
    unitTemperature: "C",
    searchedGeolocations: [],
    weatherForecast: null,
  },
  mutations: {
    setWeatherForecast (state, weatherForecast) {
      state.weatherForecast = weatherForecast;
    },
    setIsSidebarOpen (state, value) {
      state.isSidebarOpen = value;
    },
    setSearchedGeolocations (state, geolocations) {
      state.searchedGeolocations = geolocations;
    },
    setIsLoading (state, value) {
      state.isLoading = value;
    },
    setUnitTemperature (state, unitTemperature) {
      state.unitTemperature = unitTemperature;
    },
  },
  actions: {
    async getGeoLocationIDByLattLong ({ dispatch, commit }, { latitude, longitude }) {
      try {
        commit("setIsLoading", true);

        const response = await axios(`https://api.allorigins.win/raw?url=https://www.metaweather.com/api/location/search/?lattlong=${latitude},${longitude}`);

        const { woeid } = response.data[0];

        const weatherForecast = await dispatch("getWeatherForecast", woeid);

        commit("setWeatherForecast", weatherForecast);

        commit("setIsLoading", false);

      } catch (e) {
        throw new Error(e.message);
      }
    },
    async getWeatherForecast (_context, geolocationID) {
      try {
        let response = await axios(`https://api.allorigins.win/raw?url=https://www.metaweather.com/api/location/${geolocationID}`);

        const result = response.data;

        const { title: location, consolidated_weather } = result;

        const data = {
          currentDay: {
            location,
            air_pressure: consolidated_weather[0].air_pressure,
            date: moment(consolidated_weather[0].applicable_date).format("ddd, DD MMMM"),
            humidity: consolidated_weather[0].humidity,
            visibility: _.round(consolidated_weather[0].visibility),
            state: consolidated_weather[0].weather_state_name,
            temperature: _.round(consolidated_weather[0].the_temp),
            wind: {
              speed: _.round(consolidated_weather[0].wind_speed),
              direction: consolidated_weather[0].wind_direction_compass
            }
          },
          nextDays: consolidated_weather.slice(1)
                                                .map(weather => ({  state: weather.weather_state_name,
                                                                    date:  moment(weather.applicable_date).format("ddd, DD MMMM"),
                                                                    temperature: { max: _.round(weather.max_temp),
                                                                                   min: _.round(weather.min_temp) }}))
        }

        return data;

      } catch (e) {
        throw new Error(e.message);
      }
    },
    async getGeoLocationIDByName ({ commit }, search) {
      try {
          const response = await axios(`https://api.allorigins.win/raw?url=https://www.metaweather.com/api/location/search/?query=${search}`);

          const { data } = response;

          const geolocations = data.map(geolocation => ({ locationName: geolocation.title,
                                                          locationID: geolocation.woeid }))

          commit("setSearchedGeolocations", geolocations);
      } catch (e) {
        throw new Error(e.message);
      }
    },
    async getDefaultLocation ({ commit, dispatch }) {
      // London
      try {
        const weatherForecast = await dispatch("getWeatherForecast", 44418);
  
        commit("setWeatherForecast", weatherForecast);
  
        commit("setIsLoading", false);
      } catch (e) {
        throw new Error(e.message);
      }
    },
    async changeLocation ({ dispatch, commit }, geolocationID) {
      try {
        commit("setIsLoading", true);

        const weatherForecast = await dispatch("getWeatherForecast", geolocationID);

        commit("setWeatherForecast", weatherForecast);

      } catch (error) {
        console.log('hay un error boleta');
      } finally {
        commit("setIsLoading", false);
      }
    },
    async changeUnitTemperatureToFahrenheit ({ commit, dispatch, state }) {
      commit("setUnitTemperature", "F");

      const weatherForecast = _.cloneDeep(state.weatherForecast);

      weatherForecast.currentDay.temperature = await dispatch("convertCelsiusToFahrenheit", weatherForecast.currentDay.temperature);

      weatherForecast.nextDays.forEach(async day => {
                                for (let property in day.temperature) {
                                  day.temperature[property] = await dispatch("convertCelsiusToFahrenheit", day.temperature[property]);
                                }
                              });

      commit("setWeatherForecast", weatherForecast);
    },
    async changeUnitTemperatureToCelsius ({ commit, dispatch, state }) {
      commit("setUnitTemperature", "C");

      const weatherForecast = _.cloneDeep(state.weatherForecast);

      weatherForecast.currentDay.temperature = await dispatch("convertFahrenheitToCelsius", weatherForecast.currentDay.temperature);

      weatherForecast.nextDays.forEach(async day => {
                                for (let property in day.temperature) {
                                  day.temperature[property] = await dispatch("convertFahrenheitToCelsius", day.temperature[property]);
                                }
                              });

      commit("setWeatherForecast", weatherForecast);
    },
    getCurrentLatitudeLongitude () {
      return new Promise(function(resolve, reject) {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });
    },
    closeSidebar ({ commit }) {
      commit("setIsSidebarOpen", false);
    },
    openSidebar ({ commit }) {
      commit("setIsSidebarOpen", true);
    },
    convertCelsiusToFahrenheit (_context, temperature) {
      return _.round((temperature * 9) / 5 + 32);
    },
    convertFahrenheitToCelsius (_context, temperature) {
      return _.round((temperature - 32) * 5 / 9);
    },
  },
  modules: {
  }
})
